const keys = ['AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VA', 'VT', 'WA', 'WI', 'WV', 'WY'];

export default class UsMap {
    constructor(element, states) {
        this.active = null;
        this.container = element.querySelector('.map__container');

        this.buttons = Array.from(document.querySelectorAll('button[data-dir]'));
        this.markers = Array.from(document.querySelectorAll('.map__markers'));
        this.slidesBgAsset = Array.from(document.querySelectorAll('.section-market-map__slide-bg-asset'));
        this.slidesContents = Array.from(document.querySelectorAll('.section-market-map__slide-contents'));
        this.states = [];
        this.buttonClicked = this.buttonClicked.bind(this);
        this.markerClicked = this.markerClicked.bind(this);
        this.stateClicked = this.stateClicked.bind(this);

        const enabled = states; // ['AL', 'FL', 'GA', 'KY', 'NC', 'OH', 'OK', 'SC', 'TN', 'TX'];
        const svg = element.querySelector('svg.map__svg');

        this.markers.forEach(marker => {
            enabled.push(marker.getAttribute('data-key'));
        });

        let i; let l; let key; let
            shape;

        for (i = 0, l = this.markers.length; i < l; i++) {
            this.markers[i].addEventListener('click', this.markerClicked);
        }

        for (i = 0, l = keys.length; i < l; i++) {
            key = keys[i];
            shape = svg.getElementById(`state-${key}`);
            shape.setAttribute('data-key', key);
            if (enabled.indexOf(key) >= 0) {
                shape.parentNode.removeChild(shape);
                svg.appendChild(shape);
                shape.setAttribute('class', 'state enabled');
                shape.addEventListener('click', this.stateClicked);
                this.states.push(shape);
            } else {
                shape.setAttribute('class', 'state disabled');
            }
        }
        this.enabled = enabled;

        for (i = 0, l = this.buttons.length; i < l; i++) {
            this.buttons[i].addEventListener('click', this.buttonClicked);
        }

        this.setActive(null);
    }

    setActive(active) {
        this.active = active;

        if (this.active !== null) {
            this.container.setAttribute('data-active', this.active);
        } else {
            this.container.removeAttribute('data-active');
        }

        this.states.forEach(shape => {
            const key = shape.getAttribute('data-key');
            if (key === active) {
                const svg = shape.parentNode;
                svg.removeChild(shape);
                svg.appendChild(shape);
                shape.setAttribute('class', 'state active');
            } else if (active !== null) {
                shape.setAttribute('class', 'state inactive');
            } else {
                shape.setAttribute('class', 'state enabled');
            }
        });

        this.markers.forEach(element => {
            const key = element.getAttribute('data-key');
            if (key === active) {
                element.classList.add('show');
            } else {
                element.classList.remove('show');
            }
        });

        this.slidesBgAsset.forEach(asset => {
            const key = asset.getAttribute('data-slide-bg-asset');
            if (key === active || key === 'default') {
                asset.classList.add('active');
            } else {
                asset.classList.remove('active');
            }
        });

        this.slidesContents.forEach(asset => {
            const key = asset.getAttribute('data-slide-contents');
            if (active === null && key === 'default') {
                asset.classList.add('active');
            } else if (key === active) {
                asset.classList.add('active');
            } else {
                asset.classList.remove('active');
            }
        });

        if ('activeCallback' in this) {
            this.activeCallback();
        }
    }

    buttonClicked(event) {
        event.preventDefault();
        const dir = event.currentTarget.getAttribute('data-dir');
        if (this.active === null) {
            if (dir === 'prev') {
                this.setActive(this.enabled[this.states.length - 1]);
            } else if (dir === 'next') {
                this.setActive(this.enabled[0]);
            }
        } else {
            let index = this.enabled.indexOf(this.active);
            if (dir === 'prev') {
                index -= 1;
            } else if (dir === 'next') {
                index += 1;
            }
            if (index < 0 || index >= this.states.length) {
                this.setActive(null);
            } else {
                this.setActive(this.enabled[index]);
            }
        }
    }

    markerClicked(event) {
        event.preventDefault();
        // do nothing because on mobile people need to click on the marker to get the hover effect
        // this.setActive(null);
    }

    stateClicked(event) {
        event.preventDefault();
        const key = event.currentTarget.getAttribute('data-key');
        if (this.active === key) {
            this.setActive(null);
        } else {
            this.setActive(key);
        }
    }
}
